export class DpdExportRepeaterSettingsField {
	constructor(el) {
		this.el = el;
		this.props = this.getProps(el);
		this.refs = this.getRefs(el);
		this.inputsData = this.getInputsData(el);
	}

	init() {
		if (this.inputsData.length) {
			this.inputsData.forEach((inputData) => {
				this.addRow(inputData);
			});
		} else {
			this.addRow();
		}

		this.refs.addButton.onclick = (e) => {
			e.preventDefault();
			this.addRow();
		};
	}

	getRefs(el) {
		let result = {};
		[...el.querySelectorAll('[data-ref]')].forEach((ref) => {
			result[ref.dataset.ref] = ref;
		});
		return result;
	}

	getProps(el) {
		return JSON.parse(el.dataset.props);
	}

	getInputsData(el) {
		return JSON.parse(el.dataset.inputsData);
	}

	createFromHTML(html = '') {
		let element = document.createElement(null);
		element.innerHTML = html;
		return element.firstElementChild;
	}

	addRow(inputData = []) {
		const that = this;

		let newRow = this.createFromHTML(this.renderRow(inputData));
		const rowRefs = this.getRefs(newRow);

		rowRefs.removeButton.onclick = (e) => {
			e.preventDefault();
			that.removeRow(newRow);
		};

		this.refs.rowList.appendChild(newRow);
	}

	removeRow(row) {
		if (this.refs.rowList.children.length <= 1) return;

		row.remove();
		this.el.focus();

		if (this.refs.rowList.children.length < this.props.maxRows) {
			this.refs.addButton.style.display = '';
		}
	}
}
